import { render, staticRenderFns } from "./listItemExtras.vue?vue&type=template&id=6f4da3c2&scoped=true&"
import script from "./listItemExtras.vue?vue&type=script&lang=js&"
export * from "./listItemExtras.vue?vue&type=script&lang=js&"
import style0 from "./listItemExtras.vue?vue&type=style&index=0&id=6f4da3c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4da3c2",
  null
  
)

export default component.exports